import React from "react";
import { Result } from "antd";
import { withRouter } from "react-router-dom";
const Forbidden = () => {
  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
    />
  );
};

export default withRouter(Forbidden);